export const LOGIN = "LOGIN";
export const REGISTER = "REGISTER";
export const PASS_RESET = "PASS_RESET";
export const USER_PROFILE = "USER_PROFILE";
export const USER = "user";